<template>
  <div>
    <div v-if="!fileName">
      <i>{{text}} not available</i>
    </div>
    <div v-else>
      <strong>
        <a class="el-button" :href="url"
        :download="fileName">
          <i :class="'el-icon-' + icon"></i>{{text}} - {{fileName}}
        </a>
      </strong>
      <!--
              <download-button :url="url" :icon="'el-icon-' + icon" :text="text + ' - ' + fileName">
              </download-button>
      -->
    </div>

  </div>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import FormattingMixins from '@/mixins/FormattingMixins'
import DownloadButton from '@/components/atoms/files/DownloadButton'

export default {
  name: 'file-download',

  mixins: [PostMixins, FormattingMixins],

  components: {
    DownloadButton
  },

  props: {
    fileList: {
      type: Array,
      required: true
    },

    text: {
      type: String,
      default: 'Download'
    },

    icon: {
      type: String,
      default: 'view'
    },

    type: {
      type: String,
      default: 'plain'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    afterDownload: {
      type: Function,
      default: null
    }
  },

  computed: {

    url: function () {
      if (this.files && typeof this.current === 'number') {

        if (this.files && this.files[this.current].id) {
          return this.getEndpoint('file/download/' + this.files[this.current].url + '/' + this.urlSafeName(this.files[this.current].name))
        }

      }
    }, // url


    fileName: function () {
      if (this.files && typeof this.current === 'number' && this.files[this.current].name) {
        return this.files[this.current].name
      } else {
        return null
      }
    }
  },

  data () {
    return {
      isDisabled: this.disabled,
      files: this.fileList,
      current: (this.fileList && this.fileList.length > 0) ? 0 : null
    }
  },


  mounted () {
    this.files = this.fileList
  }
}

</script>

<style scoped>
a {text-decoration: none;}
</style>
